var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('checkbox-input',{attrs:{"name":_vm.name,"label":_vm.label,"items":_vm.filteredUsers,"checked":_vm.checked,"dimension":_vm.dimension,"error":_vm.phpError,"for-else-message":"No users available"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }